const language = {
	spanish: {
		header_title: "Aplicaciones ",
		header_yellow_span: "Móviles",
		aplicaciones_yellow_title: "Aplicaciones móviles",
		aplicaciones_bold_title:
			"Las nuevas dinámicas de los negocios digitales demandan movilidad. Además, en el mundo de la logística y seguridad, donde se deben tomar decisiones rápidas en campo, es esencial contar con la mayor cantidad de datos a la mano y al instante.",
		aplicaciones_bold_text:
			"Es por ello que todos los desarrollos de Foresight GPS tienen una versión en aplicación móvil para hacer más fluida la experiencia.",
		aplicaciones_paragraphs: [
			"Nuestra aproximación al desarrollo móvil es híbrida. Esto quiere decir que todas nuestras aplicaciones están desarrolladas para sistemas Android y iOS. Nuestro framework de desarrollo es Ionic.",
		],
		ionic_develop_yellow_title: "¿Por qué desarrollar en Ionic?",
		ionic_develop_bold_title:
			"Ionic es un framework de código abierto que se utiliza en el desarrollo de aplicaciones móviles híbridas. Combinando el código HTML5, CSS y JavaScript obtenemos aplicaciones con una interfaz amigable e intuitiva para el usuario.",
		ionic_develop_bold_text:
			"De esta forma, desarrollando un único código es posible crear aplicaciones tanto en Android como en iOS.",
		ionic_develop_paragraphs: [
			"Aplicaciones robustas: Trabaja perfectamente con Angular, lo que hace que se pueda desarrollar una arquitectura robusta para apps. También podemos programas en algún otro framework de JavaScript, y Ionic lo permite.",
			"Basado en el lenguaje de el web: Una de las grandes ventajas de este marco de desarrollo es que está basado en JavaScript, que es el lenguaje de programación de la web. Esto hace que Ionic aproveche la versatilidad y poder de este lenguaje de programación.",
			"Pulcro: Es moderno y está diseñado para trabajar con lo más actual, con un diseño limpio y pulcro. Los componentes son atractivos y se puede integrar cualquier tipografía.",
			"Apps nativas: Ahora con las nuevas versiones de Ionic se puede aumentar el rendimiento de las aplicaciones aprovechando las ventajas de cada uno de los sistemas.",
		],
		our_apps_yellow_title: "Nuestras apps",
		app_1: {
			boldText: "G-Evolution Mobile",
			text: "Esta es la aplicación de nuestra plataforma G-Evolution. Con ella podrás tener una experiencia mobile de nuestra poderosa herramienta de rastreo, logística y seguridad.",
		},
		app_2: {
			boldText: "G-Log",
			text: "Con esta app el conductor podrá llevar un control de sus horas de conducción. Ideal para llevar un control de bitácoras de manejo, la app está adaptada para cumplir con regulaciones legales de horas de trabajo para conductores.",
		},
		app_3: {
			boldText: "Smartrace",
			text: "Con esta aplicación puedes convertir cualquier teléfono inteligente en un dispositivo rastreable por la plataforma G-Evolution. Ideal para el control y monitoreo de fuerzas de ventas o personal de primera línea.",
		},
		app_4: {
			boldText: "Pet Tracker",
			text: "Junto con un dispositivo GPS de alta precisión, Pet Tracker le permitirá a los usuarios tener rastreadas a sus mascotas en todo momento. Incluso podrá crear áreas de seguridad y recibir alertas cuando la mascota cruce los límites.",
		},
		app_5: {
			boldText: "G-Pilot",
			text: "Es una aplicación que le permite a los conductores capturar imágenes de entregas o de incidencias en la vía para un mejor control. Además le permite al conductor tener un registro de sus rutas asignadas. Ideal para empresas con complejas dinámicas de despachos.",
		},
		app_6: {
			boldText: "Family app",
			text: "Esta app es ideal para los usuarios que quieren saber donde está su vehículo (automóvil, motocicleta o bote) o su flota familiar. Tiene una interfaz intuitiva y amigable. Además le permite crear geocercas y una interesante variedad de alertas de seguridad.",
		},
		develop_yellow_title: "Desarrollos personalizados y marca blanca",
		develop_bold_title:
			"Al tener la propiedad del código de todas nuestras aplicaciones, podemos adaptarlas a cualquier necesidad de marca o nueva funcionalidad. El cielo es el límite.",
	},
	english: {
		header_title: "Mobile ",
		header_yellow_span: "Apps",
		aplicaciones_yellow_title: "Mobile Apps",
		aplicaciones_bold_title:
			"Modern digital business dynamics demand mobility. It is essential in the world of logistics and security to have as much data as possible always at hand to be able to make quick and accurate decisions.",
		aplicaciones_bold_text:
			"Therefore, ForesightGPS developments have a mobile app version, to give the user a better experience.",
		aplicaciones_paragraphs: [
			"Our approach to mobile development is hybrid, all our apps are available for Android and iOS systems. Our development framework is Ionic.",
		],
		ionic_develop_yellow_title: "¿Why Develop at Ionic?",
		ionic_develop_bold_title:
			"Ionic is an open-source framework used in hybrid mobile app development. Taking advantage of HTML5, CSS and JavaScript code we can obtain friendly and intuitive interface apps for the user.",
		ionic_develop_bold_text:
			"This way, by developing a single code, it is possible to create apps on both Android and iOS.",
		ionic_develop_paragraphs: [
			"Robust applications: It works perfectly with Angular, which makes possible the development of a robust architecture for apps. We can also program in another JavaScript framework and Ionic still allows it.",
			"Based on the language of the web: One of the great advantages of this framework is that it is based on JavaScript, the language of the web. Ionic takes advantage of the versatility and power of this programming language.",
			"Neat: A modern platform designed to work with the most current and neat design, its components are attractive, and any typeface can be integrated.",
			"Native Apps: With the new versions of Ionic, app performance can be increased by taking advantage of each of the systems.",
		],
		our_apps_yellow_title: "Our Apps",
		app_1: {
			boldText: "G-Evolution Mobile",
			text: "This is the app for our G-Evolution platform. Using it will give you the mobile experience of powerful tracking, logistics and security tools.",
		},
		app_2: {
			boldText: "G-Log",
			text: "With this app the driver will be able to keep track of his driving hours. Ideal for keeping track of driving logs, the app is adapted to comply with legal regulations on working hours for drivers.",
		},
		app_3: {
			boldText: "Smartrace",
			text: "With this application you can turn any smartphone into a trackable device by the G-Evolution platform. Ideal for the control and monitoring of sales forces or front line personnel.",
		},
		app_4: {
			boldText: "Pet Tracker",
			text: "Together with a high-precision GPS device, Pet Tracker will allow users to keep track of their pets at all times. You will even be able to create safety areas and receive alerts when the pet crosses the boundaries.",
		},
		app_5: {
			boldText: "G-Pilot",
			text: "It is an application that allows drivers to capture images of deliveries or incidents on the road for better control. It also allows drivers to have a record of their assigned routes. Ideal for companies with complex dispatch dynamics.",
		},
		app_6: {
			boldText: "Family app",
			text: "This app is ideal for users who want to know where their vehicle (car, motorcycle or boat) or their family fleet is. It has an intuitive and user-friendly interface. It also allows you to create geofences and an interesting variety of security alerts.",
		},
		develop_yellow_title: "Custom development and white labeling",
		develop_bold_title:
			"By owning the code of all our applications, we can adapt them to any branding needs or new functionality. The sky is the limit.",
	},
};

export default language;
